import type { FieldCollection } from '@feathr/blackbox';
import { FieldDataType } from '@feathr/blackbox';

/**
 * The option shape the field-related select option components read from. Every field is optional
 * because the options come from several sources — custom fields, default field definitions, and
 * synthetic "create new field" entries — each of which populates a different subset.
 */
export interface IFieldOptionData {
  collection?: FieldCollection;
  data_type?: FieldDataType;
  id?: string;
  key?: string;
  label?: string;
  name?: string;
  u_key?: string;
  value?: string | number | boolean | Date;
}

/**
 * Infers a field's data type from a sample value, for options that carry a value but no explicit
 * `data_type`.
 */
export function valueToFieldDataType(
  value: string | number | boolean | Date | undefined,
): FieldDataType {
  if (typeof value === 'string') {
    return FieldDataType.str;
  }
  if (typeof value === 'number') {
    return FieldDataType.int;
  }
  if (typeof value === 'boolean') {
    return FieldDataType.bool;
  }
  if (value instanceof Date) {
    return FieldDataType.date;
  }
  return FieldDataType.str;
}
